import { render } from "./TheAdminVideos.vue?vue&type=template&id=6663397e&scoped=true&ts=true"
import script from "./TheAdminVideos.vue?vue&type=script&lang=ts"
export * from "./TheAdminVideos.vue?vue&type=script&lang=ts"

import "./TheAdminVideos.vue?vue&type=style&index=0&id=6663397e&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6663397e"]])

export default __exports__